<template>
  <div>
    <InfoLayout
      v-if="!isMobile"
      :current-path="reverseFull({ name: 'contacts' })"
      :is-policy="false"
    >
      <template #title>
        {{ t('Контакты', options) }}
      </template>
      <template #content>
        <component
          :is="isMobile ? ContactsContentMobile : ContactsContentDesktop"
          data-qa="service_list_content_list"
        />
      </template>
    </InfoLayout>
    <component
      :is="isMobile ? ContactsContentMobile : ContactsContentDesktop"
      v-else
      data-qa="service_list_content_list"
    />
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import I18NextVue from 'i18next'
import { useContextStore, useURLStore } from 'src/store'
import ContactsContentMobile from 'src/components/pages/info/contacts/components/ContactsContentMobile.vue'
import ContactsContentDesktop from 'src/components/pages/info/contacts/components/ContactsContentDesktop.vue'
import type { ContextStore } from 'src/components/pages/info/contacts/types'
import InfoLayout from 'src/layouts/info-pages/InfoLayout.vue'

const { t, language } = I18NextVue
const options = { ns: language }

const { context }: ContextStore = useContextStore()
const { reverseFull } = useURLStore()
const isMobile = computed(() => context?.flavour === 'mobile')
</script>
